let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("i7B1x")).then(() => parcelRequire('bBHDr'));